import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {fetchRewards} from "./UserRewardActions";
import {AppState} from "../RootReducer";
import {AccountCard} from "../ui/AccountUI";
import {Currency, RewardType, UserGameReward} from "../http/protocol";
import {BrandA, BrandLink} from "../ui/buttons/buttons";
import {getContainer} from "../ioc/IOCSetup";
import {Modal} from "react-bootstrap";
import {MenuCloseButton} from "../ui/navigation/Menu";
import {t} from "../i18n";
import {formatDate} from "../utils/date";
import {getActiveCurrencyCode, getCurrencyByCode} from "../selectors/user-selectors";
import {useHistory} from "react-router-dom";
import {fetchBalance, setActiveCurrency} from "../user/UserActions";
import {Redirect} from "react-router";
import {CasinoStatus} from "../casino/CasinoReducer";
import {loadCasinoGames} from "../casino/CasinoActions";
import {RequestState} from "../bonus/BonusReducer";
import {getCasinoGameById} from "../selectors/casino-selectors";
import CurrencyFormatter from "../utils/CurrencyFormatter";
import {getCurrencyDefinitionByCode} from "../selectors/settings-selectors";

export const UserRewardsPage = () => {
    let activeCurrency = useSelector((app : AppState) => getActiveCurrencyCode(app));
    let casinoStatus = useSelector((app : AppState) => app.casino.status);
    const dispatch = useDispatch();
    useEffect(() => {
        window.scroll(0,0);
        dispatch(fetchRewards(true) as any);
        if(casinoStatus != CasinoStatus.DONE) {
            dispatch(loadCasinoGames() as any);

        }
    },[dispatch])
    const rewards  = useSelector((app : AppState) => app.rewards.rewards);
    const status = useSelector((app : AppState) => app.rewards.rewardsStatus)
    if((casinoStatus == CasinoStatus.LOADING || casinoStatus == CasinoStatus.NONE) || status == RequestState.IN_PROGRESS) {
        return (
            <div className={"content-padding"}>
                <div id="jsLoader" className="js-loader">
                    <div className="lds-facebook">
                        <div/>
                        <div/>
                        <div/>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className={"content-padding"}>
            <h4 className={"section"}>{t("rewards.title")}</h4>
            {rewards.map((r : UserGameReward) => (
                <AccountCard key={r.id}>
                    <Reward reward={r} onCloseClaimDialog={() => dispatch(fetchRewards() as any)} activeCurrency={activeCurrency}/>
                </AccountCard>
            ))}
        </div>
    )
}
export enum RewardClaimedStatus {
    NONE, IN_PROGRESS, COMPLETE, ERROR
}
function  usePrevious<T>(value : T) {
    const ref = useRef<T>();
    useEffect(() => {
        ref.current = value;
    }, [value]); // Only re-run if value changes

    return ref.current;

}
export const Reward = ( props : { reward : UserGameReward, onCloseClaimDialog : () => void, activeCurrency? : string}) => {
    const [status, setStatus] = useState(RewardClaimedStatus.NONE);
    const dispatch = useDispatch();
    const claim = () => {
        setStatus(RewardClaimedStatus.IN_PROGRESS);
        props.reward?.id && getContainer().getUserRewardService().claimReward(props.reward.id).then(()=>{
            setStatus(RewardClaimedStatus.COMPLETE);
        }).catch(e => {
            setStatus(RewardClaimedStatus.ERROR);
        })
    };
    const close = () => {
        dispatch(fetchBalance() as any);
        props.onCloseClaimDialog();
        setStatus(RewardClaimedStatus.NONE);

    }
    const previousCurrency = usePrevious(props.activeCurrency);

    let history = useHistory();
    const url = "/casino/play/"+ props.reward.gameId+"/freespins";
    const play = () => {
        if(props.reward?.currencyCode === props.activeCurrency) {
            history.push(url);
        } else if(props.reward?.currencyCode) {
            dispatch(setActiveCurrency(props.reward?.currencyCode))
        }
    }

    let r = props.reward;
    const game = useSelector((app : AppState) => getCasinoGameById(app,r.gameId ?? -1))
    const currency = useSelector((app : AppState) => getCurrencyDefinitionByCode(app,r.currencyCode ?? ""))

    if(previousCurrency !== props.activeCurrency && status == RewardClaimedStatus.COMPLETE) {
        return <Redirect to={url} />
    }

    if(!game && props.reward.rewardTemplate?.rewardType == RewardType.freespins) {
        return <></>
    }

    return (
       <>
           <Modal dialogClassName={"action-dialog"} show={status == RewardClaimedStatus.ERROR || status == RewardClaimedStatus.COMPLETE}>
               <Modal.Header>
                   <div className={"menu-close"} onClick={close}>
                       <MenuCloseButton />
                   </div>
               </Modal.Header>
               <Modal.Body>
                   {status == RewardClaimedStatus.COMPLETE && (
                       <>
                           <h4>{t("rewards.claim-dialog.title")}</h4>
                           <p>
                               {props.reward.rewardTemplate?.rewardType == RewardType.freespins && (
                                   <>{t("rewards.claim-dialog.text", { freespins : r.nrOfFreeSpins})}</>
                               )}
                               {props.reward.rewardTemplate?.rewardType == RewardType.cash && (
                                   <>{t("rewards.claim-dialog.cash-text", { currencyName : currency?.name ?? "", amount : CurrencyFormatter.formatWithSymbol(currency, props.reward.amount)})}</>
                               )}
                               {props.reward.rewardTemplate?.rewardType == RewardType.freebet && (
                                   <>{t("rewards.claim-dialog.freebet-text", { currencyName : currency?.name ?? "", amount : CurrencyFormatter.formatWithSymbol(currency, props.reward.amount)})}</>
                               )}
                           </p>
                           <div className={"actions"}>
                               <BrandA className={"btn btn-secondary-popup"} onClick={close}>{t("rewards.claim-dialog.close")}</BrandA>
                               {props.reward.rewardTemplate?.rewardType == RewardType.freespins && (
                                   <BrandA onClick={play} className={"btn btn-cta"}>{t("rewards.claim-dialog.play")}</BrandA>
                               )}
                               {props.reward.rewardTemplate?.rewardType == RewardType.freebet && (
                                   <BrandLink to={"/sportsbook"} className={"btn btn-cta"}>{t("rewards.claim-dialog.play-sports")}</BrandLink>
                               )}
                           </div>
                       </>
                   )}
                   {status == RewardClaimedStatus.ERROR && (
                       <>
                           <h4>{t("rewards.claim-dialog.title-error")}</h4>
                           <p>
                               {t("rewards.claim-dialog.text-error", { freespins : r.nrOfFreeSpins})}
                           </p>
                           <div className={"actions"}>
                               <BrandA className={"btn btn-secondary-popup"} onClick={close}>{t("rewards.claim-dialog.close")}</BrandA>
                           </div>
                       </>
                   )}
               </Modal.Body>
           </Modal>
           <div className={"row"}>
               {r.rewardTemplate?.imageUrl && (
                   <div className={"col-md-2 image"}>
                       <div className={"bonus-image reward-icon"} style={r.rewardTemplate?.iconUrl ? { backgroundImage : `url('${r.rewardTemplate?.iconUrl}')`} : {}}></div>
                   </div>
               )}
               <div className={"col-md-7 content"}>
                   {r.rewardTemplate?.rewardType == RewardType.freespins && (
                       <FreespinsReward nrOfFreeSpins={r.nrOfFreeSpins} gameName={game?.name} expires={r.expires} />
                   )}
                   {r.rewardTemplate?.rewardType == RewardType.cash && (
                       <CashReward amount={r.amount} expires={r.expires} currency={currency}/>
                   )}
                    {r.rewardTemplate?.rewardType == RewardType.freebet && (
                       <FreebetReward amount={r.amount}
                                      expires={r.expires}
                                      currency={currency}
                                      titleKey={r.rewardTemplate.titleKey}
                                      descriptionKey={r.rewardTemplate.descriptionKey}/>
                   )}
               </div>
               <div className={"col-md-3 actions"}>
                   <BrandA className={"btn btn-cta small"} loading={status != RewardClaimedStatus.NONE} onClick={()=> claim()}>{t("rewards.claim")}</BrandA>
               </div>
           </div>
       </>
    );
}
export const FreespinsReward = (props : { nrOfFreeSpins? : number, gameName? : string, expires? : Date}) => (
    <>
        <h4 dangerouslySetInnerHTML={{__html : t("rewards.freespins-title", { freespins :  props.nrOfFreeSpins, game : props.gameName})}}>
        </h4>
        <span className={"expires"}><i className={"material-icons"}>query_builder</i> {t("bonus.expires")}: {formatDate(props.expires)}</span>
        <div className={"text"} dangerouslySetInnerHTML={{__html : t("rewards.freespins-description", { freespins : props.nrOfFreeSpins, game : props.gameName})}}>
        </div>
    </>
)
export const CashReward = (props : { amount?: number, currency? : Currency, expires? : Date}) => (
    <>
        <h4 dangerouslySetInnerHTML={{__html : t("rewards.cash-title", { amount :  CurrencyFormatter.formatWithSymbol(props.currency, props.amount)})}}>
        </h4>
        <span className={"expires"}><i className={"material-icons"}>query_builder</i> {t("bonus.expires")}: {formatDate(props.expires)}</span>
        <div className={"text"} dangerouslySetInnerHTML={{__html : t("rewards.cash-description", { amount :  CurrencyFormatter.formatWithSymbol(props.currency,props.amount)})}}>
        </div>
    </>
);
const ft = (transKey : string, overrideKey? : string) : string => {
    if(overrideKey) {
        return overrideKey;
    }
    return transKey;
}
export const FreebetReward = (props : { amount?: number, currency? : Currency, expires? : Date, titleKey? : string, descriptionKey?: string}) => {
    console.log("FreebetReward component", props);
    return (
        <>
            <h4 dangerouslySetInnerHTML={{__html : t(ft("rewards.freebet-title", props.titleKey), { amount :  CurrencyFormatter.formatWithSymbol(props.currency, props.amount)})}}>
            </h4>
            <span className={"expires"}><i className={"material-icons"}>query_builder</i> {t("bonus.expires")}: {formatDate(props.expires)}</span>
            <div className={"text"} dangerouslySetInnerHTML={{__html : t(ft("rewards.freebet-description", props.descriptionKey), { amount :  CurrencyFormatter.formatWithSymbol(props.currency,props.amount)})}}>
            </div>
        </>
    )
}